/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Filters_Sortclosingdatedesc4Inputs */

const en_coinvestments_filters_sortclosingdatedesc4 = /** @type {(inputs: Coinvestments_Filters_Sortclosingdatedesc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Closing date (latest)`)
};

/**
* | output |
* | --- |
* | "Closing date (latest)" |
*
* @param {Coinvestments_Filters_Sortclosingdatedesc4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_filters_sortclosingdatedesc4 = /** @type {((inputs?: Coinvestments_Filters_Sortclosingdatedesc4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Filters_Sortclosingdatedesc4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_filters_sortclosingdatedesc4(inputs)
});
export { coinvestments_filters_sortclosingdatedesc4 as "coInvestments_filters_sortClosingDateDesc" }